import { useEffect, useState } from 'react';

const navLinks = [
  { label: '实时快讯', href: '#stream' },
  { label: '首发爆料', href: '#release' },
  { label: '热评广场', href: '#discuss' },
  { label: '图文精选', href: '#gallery' },
  { label: '热门话题', href: '#topics' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? 'bg-background-50/95 border-b border-background-200/80 backdrop-blur'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-shell items-center justify-between gap-4 px-4 md:px-6">
        <a
          href="#top"
          className={`flex items-center gap-2.5 cursor-pointer ${solid ? 'text-foreground-950' : 'text-background-50'}`}
        >
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md ${
              solid ? 'bg-primary-500 text-background-50' : 'bg-background-50 text-primary-600'
            }`}
          >
            <i className="ri-radar-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide">免费看料</span>
            <span className={`mt-0.5 text-[10px] tracking-[0.2em] ${solid ? 'text-foreground-500' : 'text-background-100/80'}`}>
              REAL-TIME FEED
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`rounded-md px-3 py-2 text-sm transition-colors cursor-pointer ${
                solid
                  ? 'text-foreground-700 hover:bg-background-100 hover:text-primary-600'
                  : 'text-background-100/90 hover:bg-background-50/10 hover:text-background-50'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <span
            className={`hidden items-center gap-2 rounded-full border px-3 py-1.5 text-xs sm:inline-flex ${
              solid
                ? 'border-secondary-200 bg-secondary-50 text-secondary-800'
                : 'border-background-50/30 bg-background-50/10 text-background-50'
            }`}
          >
            <span className={`live-dot relative inline-flex h-1.5 w-1.5 rounded-full ${solid ? 'text-secondary-500' : 'text-accent-300'}`}>
              <span className={`h-1.5 w-1.5 rounded-full ${solid ? 'bg-secondary-500' : 'bg-accent-300'}`}></span>
            </span>
            实时在线
          </span>

          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            订阅提醒
          </a>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
              solid ? 'text-foreground-950 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/10'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/80 bg-background-50 md:hidden">
          <nav className="mx-auto flex max-w-shell flex-col px-4 py-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-2 py-3 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="mt-2 mb-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              订阅提醒
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}